export default "__VITE_ASSET__qwswJKYa__"